/**
 * @generated SignedSource<<fa34ba6f472e0b8148f1264eff626129>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Rows_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Row_rules">;
  readonly " $fragmentType": "Rows_rules";
};
export type Rows_rules$key = {
  readonly " $data"?: Rows_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"Rows_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Rows_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Row_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "b4b335939ad75aad9e255c08b8521ec5";

export default node;
